var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    !_vm.item.SizeTableID
      ? _c("div", { staticClass: "sidebar-empty" }, [
          _vm._v(_vm._s(_vm.$ct("sidebar.product-size-stock.no-size-table"))),
        ])
      : _vm.loading
      ? _c(
          "div",
          { staticClass: "sidebar-loading" },
          [_c("w-progress-circular", { attrs: { small: "" } })],
          1
        )
      : _vm.sizeStocks.length == 0
      ? _c("div", { staticClass: "sidebar-empty" }, [
          _vm._v(_vm._s(_vm.$ct("sidebar.product-size-stock.no-stock"))),
        ])
      : _c(
          "div",
          { staticClass: "sidebar-table-wrap" },
          [
            _c(
              "app-custom-table",
              {
                staticClass: "sidebar-table",
                attrs: { cellpadding: "0", cellspacing: "0" },
              },
              [
                _c("thead", [
                  _c(
                    "tr",
                    [
                      _c("th", [
                        _vm._v(
                          _vm._s(_vm.$ct("sidebar.product-size-stock.size"))
                        ),
                      ]),
                      _vm._l(_vm.locations, function (loc) {
                        return _c(
                          "th",
                          { key: loc.id, staticClass: "amount" },
                          [_vm._v(_vm._s(loc.name))]
                        )
                      }),
                      _c("th", { staticClass: "amount" }, [
                        _vm._v(
                          _vm._s(_vm.$ct("sidebar.product-size-stock.total"))
                        ),
                      ]),
                    ],
                    2
                  ),
                ]),
                _c(
                  "tbody",
                  _vm._l(_vm.sizeStocks, function (s, i) {
                    return _c(
                      "tr",
                      {
                        key: i,
                        class: { "out-of-stock": s.getTotalInStock() <= 0 },
                      },
                      [
                        _c("td", [
                          _vm._v(
                            _vm._s(
                              s.SizeTableEntry ? s.SizeTableEntry.Name : "?"
                            )
                          ),
                        ]),
                        _vm._l(_vm.locations, function (loc) {
                          return _c(
                            "td",
                            { key: loc.id, staticClass: "amount" },
                            [
                              _vm._v(
                                _vm._s(_vm.print(s.getStockAtLocation(loc.id)))
                              ),
                            ]
                          )
                        }),
                        _c("td", { staticClass: "amount" }, [
                          _c("b", [
                            _vm._v(_vm._s(_vm.print(s.getTotalInStock()))),
                          ]),
                        ]),
                      ],
                      2
                    )
                  }),
                  0
                ),
              ]
            ),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }